import Div from "@jumbo/shared/Div";
import {
  Alert,
  Autocomplete,
  Avatar,
  Box,
  Button,
  ButtonGroup,
  Chip,
  FormControl,
  InputLabel,
  ListItemAvatar,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import Select from "@mui/material/Select";
import DDImage from "../../../../component/DDImage";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import Stack from "@mui/material/Stack";
import moment from "moment/moment";
import React, { useState } from "react";
import { useAppMutation } from "../../../../services";
import adminServices from "../../../../services/admin-services";
import { isPastDate, timings } from "../../../../utils/constants/appActions";
import { useTranslation } from "react-i18next";
import LoadingButton from "@mui/lab/LoadingButton";
import { useCalendarContext } from "../context";
import StudentInfoForm from "../StudentInfoForm";
import parentServices from "../../../../services/parent-services";

const BookingForm = ({
  hide,
  showTeacherFeedback,
  appointment,
  setAppointment,
}) => {
  const [type] = React.useState("courses");
  const [showCancelConfirmation, setShowCancelConfirmation] = useState(false);
  const [pastDate, setPastDate] = useState(false);
  const [isEditable, setEditable] = useState(false);
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const { t } = useTranslation();
  const { globalState, setGlobalState } = useCalendarContext();
  const [children, setChildren] = React.useState([]);
  const [open, setOpen] = React.useState(false);
  const [minDate, setMinDate] = useState();
  const [maxDate, setMaxDate] = useState();
  const [availableDates, setAvailableDates] = useState([]);
  const [sTimings, setSTimings] = useState([]);
  const [cancelReason, setCancelReason] = useState("");
  const [openChildInfoDialog, setOpenChildInfoDialog] = useState(false);
  const [values, setValues] = React.useState({
    startDate: "",
    startTime: "",
    title: "Student Booking",
    description: "",
    subscriptionId: "",
    teacherId: "",
    studentId: "",
  });

  const [searchResults, setSearchResults] = React.useState([]);

  const [inputValue, setInputValue] = useState("");
  const [options, setOptions] = useState([]);

  console.log("-------vvv------", globalState);

  const {
    mutate: loadAvailableDates,
    isSuccess: isLDSuccess,
    isLoading: isLDLoading,
    isError: isLDError,
    data: ldResult,
  } = useAppMutation(adminServices.loadAvailableDates);

  const {
    mutate: deleteBooking,
    isSuccess: isDBSuccess,
    isLoading: isDBLoading,
    isError: isDBError,
    data: dbResult,
  } = useAppMutation(adminServices.deleteBooking);

  const {
    mutate: cancelBooking,
    isSuccess: isCBSuccess,
    isLoading: isCBLoading,
    isError: isCBError,
    data: cbResult,
  } = useAppMutation(adminServices.cancelBooking);

  const {
    mutate: loadAvailableTimes,
    isSuccess: isLTSuccess,
    isLoading: isLTLoading,
    isError: isLTError,
    data: ltResult,
  } = useAppMutation(adminServices.loadAvailableTimes);

  const {
    mutate: updateStudentForBooking,
    isSuccess: isUSFBSuccess,
    isLoading: isUSFBLoading,
    isError: isUSFBError,
    error: usfbError,
  } = useAppMutation(adminServices.updateStudentForBooking);

  const {
    mutate: loadStudents,
    isSuccess: isCSuccess,
    data: cResult,
  } = useAppMutation(adminServices.loadStudents);

  const {
    mutate: saveBooking,
    isSuccess: isBSuccess,
    data: bResult,
    isLoading: isBLoading,
    isError: isBError,
  } = useAppMutation(adminServices.saveBooking);

  const {
    mutate: loadBooking,
    isSuccess: isLBSuccess,
    data: lbResult,
    isLoading: isLBLoading,
    isError: isLBError,
  } = useAppMutation(adminServices.loadBooking);

  const {
    mutate: loadAvailableTeachers,
    isSuccess: isESuccess,
    data: evaluators,
  } = useAppMutation(adminServices.loadAvailableTeachersBySearch);

  const {
    mutate: loadActiveSubscriptions,
    isSuccess: isLASSuccess,
    data: lasData,
  } = useAppMutation(adminServices.loadActiveSubscriptions);

  const {
    mutate: loadAvailableTimesByTeacher,
    isSuccess: isTTSuccess,
    isLoading: isTTLoading,
    isError: isTTError,
    data: ttResult,
  } = useAppMutation(adminServices.loadAvailableTimesByTeacher);

  const {
    mutate: loadAvailableDatesByTeacher,
    isSuccess: isTDSuccess,
    isLoading: isTDLoading,
    isError: isTDError,
    data: tdResult,
  } = useAppMutation(adminServices.loadAvailableDatesByTeacher);

  React.useEffect(() => {
    if (globalState.booking) {
      const booking = { ...values, ...globalState.booking };
      setValues(booking);

      console.log("booking-----------22-------->", booking);
      const studentId = booking?.studentId;

      const min = globalState.minDate;
      const max = globalState.maxDate;
      setMinDate(min);
      setMaxDate(max);

      if (booking?.bookingId) {
        loadStudents({ page: 1, size: 2000, studentId, evaluated: true });
      }

      const strDate = new Date();
      strDate.setDate(1);
      const endDate = new Date(strDate);
      strDate.setMonth(strDate.getMonth() - 3);
      endDate.setMonth(endDate.getMonth() + 4);

      console.log("Booking--------------------------------------", booking);
      if (globalState.booking.bookingId) {
        setEditable(false);
        loadBooking(globalState.booking.bookingId);
        const flag = isPastDate(globalState.booking.sstartDate);
        setPastDate(flag);
        loadEvaluators({
          studentId: booking.studentId,
          startDate: booking.startDate,
          startTime: booking.startTime,
        });
      } else {
        setEditable(true);
        loadActiveSubscriptions({
          studentId: booking.studentId,
          subscriptionId: values.subscriptionId,
          date: globalState.booking.sstartDate,
        });
      }
    }
  }, [globalState]);

  React.useEffect(() => {
    console.log("usfbError", usfbError);
  }, [isUSFBError, isUSFBSuccess]);

  React.useEffect(() => {
    if (isCBSuccess) {
      setGlobalState({
        ...globalState,
        booking: undefined,
        addEditBooking: false,
        refreshList: true,
      });
    }
  }, [isCBSuccess]);

  React.useEffect(() => {
    if (isDBSuccess) {
      setGlobalState({
        ...globalState,
        booking: undefined,
        addEditBooking: false,
        refreshList: true,
      });
    }
  }, [isDBSuccess]);

  const [subscription, setSubscription] = React.useState({});
  const [subscriptions, setSubscriptions] = React.useState([]);

  React.useEffect(() => {
    console.log("isLASSuccess", isLASSuccess, lasData);
    if (isLASSuccess && lasData) {
      const { subscription, subscriptions } = lasData;

      console.log("Subscriptions.......", subscription, subscriptions);
      setSubscriptions([...subscriptions]);
      setSubscription({ ...subscription });
      /*if (!values.subscriptionId) {
                            setValues({
                                ...values, subscriptionId:
                                lasData?.subscription?.subscriptionId
                            })
                        }*/
    }
  }, [isLASSuccess, lasData]);

  React.useEffect(() => {
    if (isLBSuccess) {
      const booking = {
        ...values,
        ...lbResult.booking,
        teacherId: lbResult.booking.teacher.teacherId,
      };
      booking.sstartDate = new Date(booking.startDate);
      const startDate = moment(booking.sstartDate).format("YYYY-MM-DD"); // laResult.startDate.slice(0, 10);
      const startTime = moment(booking.sstartDate).format("HH:mm");
      booking.startDate = startDate;
      booking.startTime = startTime;
      setValues(booking);

      loadActiveSubscriptions({
        studentId: booking.studentId,
        subscriptionId: booking.subscriptionId,
        date: booking.sstartDate,
      });

      /*loadAvailableTimes({
                            date: booking.sstartDate,
                            studentId: booking.studentId,
                            bookingId: booking.bookingId,
                            type
                        })*/
    }
  }, [isLBSuccess]);

  React.useEffect(() => {
    if (isCSuccess && cResult) {
      const c = [...cResult.students];
      setChildren(c);
      // setValues({...values, studentId : values.studentId});
    }
  }, [isCSuccess, cResult]);

  React.useEffect(() => {
    if (isLDSuccess) {
      setAvailableDates(ldResult?.availableDates);
      setValues({ ...values, sstartDate: new Date(values.startDate) });
    }
  }, [isLDError, isLDSuccess, ldResult]);

  // ✅ Teacher-based timings effect (replaces the old ltResult effect)
  React.useEffect(() => {
    // guard: need a startDate to align "HH:mm" to a full Date for expiry checks
    const startDateStr = values.startDate;
    if (!startDateStr && isTTSuccess) {
      setSTimings([]);
      return;
    }

    if (isTTSuccess && ttResult) {
      const rawTimings = Array.isArray(ttResult.timings)
        ? ttResult.timings
        : [];
      const ls = [];

      for (const t of rawTimings) {
        // build a local Date from selected day + timing "HH:mm"
        let date = new Date(`${startDateStr}T${t}`);
        const userTimezoneOffset = date.getTimezoneOffset() * 60000;
        date = new Date(date.getTime() - userTimezoneOffset);

        // 🔒 keep your subscription expiry rule
        if (subscriptions && values.subscriptionId) {
          const subscription = subscriptions.find(
            (ii) => ii.subscriptionId === values.subscriptionId,
          );
          if (subscription) {
            const expiredDate = new Date(subscription.expiredDate);
            expiredDate.setMinutes(expiredDate.getMinutes() - 30);
            // skip times after expiry window
            if (date > expiredDate) continue;
          }
        }

        // map "HH:mm" → your display pair using existing timings list
        const v = timings.find(
          (item) => item.value === moment(date).format("HH:mm"),
        );
        if (v) ls.push(v);
      }

      setSTimings(ls);
    } else if (isTTError) {
      setSTimings([]);
    }
  }, [
    isTTSuccess,
    isTTError,
    ttResult,
    values.startDate,
    values.subscriptionId,
    subscriptions,
  ]);

  React.useEffect(() => {
    if (isBSuccess) {
      setGlobalState({
        ...globalState,
        booking: undefined,
        addEditBooking: false,
        refreshList: true,
      });
    } else if (isBError) {
      setErrMsg(t("errMsg.booking"));
    }
  }, [isBError, isBSuccess]);

  const [errMsg, setErrMsg] = React.useState("");

  const loadEvaluators0 = ({ studentId, startDate, startTime, search }) => {
    const sDate = startDate ? "" + startDate : "" + values.startDate;
    const sTime = startTime ? "" + startTime : "" + values.startTime;
    const c = studentId ? studentId : values.studentId;
    const selectedStartDateTime = new Date(`${sDate}T${sTime}`);
    const selectedEndDateTime = new Date(`${sDate}T${sTime}`);

    selectedEndDateTime.setMinutes(selectedEndDateTime.getMinutes() + 29);

    const obj = {
      type,
      studentId: c,
      startDate: selectedStartDateTime,
      endDate: selectedEndDateTime,
      search,
    };
    //loadAvailableTeachers(obj);
    loadAvailableTeachers(obj, {
      onSuccess: (data) => {
        console.log("Teacher search response:", data);
        setOptions(data?.availableTeachers || []);
      },
      onError: () => setOptions([]),
    });
  };

  const normalizeTeacherOptions = (res) => {
    if (Array.isArray(res)) return res;
    if (Array.isArray(res?.availableTeachers)) return res.availableTeachers;
    if (Array.isArray(res?.teachers)) return res.teachers;
    if (Array.isArray(res?.data)) return res.data;
    return [];
  };

  const loadEvaluators = ({ studentId, search }) => {
    const c = studentId ? studentId : values.studentId;
    const selectedStartDateTime = new Date(minDate);
    const selectedEndDateTime = new Date(maxDate);

    selectedEndDateTime.setMinutes(selectedEndDateTime.getMinutes() + 29);

    const obj = {
      type,
      studentId: c,
      startDate: selectedStartDateTime,
      endDate: selectedEndDateTime,
      search,
    };
    //loadAvailableTeachersBySearch(obj);

    loadAvailableTeachers(obj, {
      onSuccess: (res) => setOptions(normalizeTeacherOptions(res)),
      onError: () => setOptions([]),
    });

    /*const sDate = startDate ? '' + startDate : '' + values.startDate;
        const sTime = startTime ? '' + startTime : '' + values.startTime;
        const c = childId ? childId : values.childId;
        const selectedStartDateTime = new Date(`${sDate}T${sTime}`);
        const selectedEndDateTime = new Date(`${sDate}T${sTime}`);

        selectedEndDateTime.setMinutes(selectedEndDateTime.getMinutes() + 29);

        const obj = {type, childId: c, startDate: selectedStartDateTime, endDate: selectedEndDateTime}
        loadAvailableTeachersBySearch(obj);*/
  };

  const handleCancelBooking = () => {
    if (!cancelReason.trim()) {
      setErrMsg(t("errMsg.cancelReason"));
    } else {
      // Proceed with cancellation action
      setErrMsg("");
      // Your cancellation logic here

      const obj = {
        bookingId: values.bookingId,
        reason: cancelReason,
      };
      cancelBooking(obj);
    }
  };
  const handleSaveBooking = () => {
    console.log(values);

    if (
      values.startTime &&
      values.startDate &&
      values.studentId &&
      values.description
    ) {
      const selectedStartDateTime = new Date(
        `${values.startDate}T${values.startTime}`,
      );
      const selectedEndDateTime = new Date(
        `${values.startDate}T${values.startTime}`,
      );
      selectedEndDateTime.setMinutes(selectedEndDateTime.getMinutes() + 30);

      const booking = {
        description: values.description,
        startDate: selectedStartDateTime,
        endDate: selectedEndDateTime,
        studentId: values.studentId,
        bookingId: values.bookingId,
        teacherId: values.teacherId,
        subscriptionId: values.subscriptionId,
      };

      saveBooking(booking);
    } else {
      setErrMsg(t("common.inputError"));
      setTimeout(() => {
        setErrMsg("");
      }, 5000);
    }
  };

  const handleChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value });
    if (prop === "subscriptionId") {
      //loadtime
    } else if (prop === "startTime") {
      //loadEvaluators({ startTime: event.target.value });
    } else if (prop === "startDate") {
      //loadEvaluators({ startDate: event.target.value });
    } else if (prop === "studentId") {
      loadActiveSubscriptions({
        studentId: event.target.value,
        subscriptionId: values.subscriptionId,
        date: values.sstartDate,
      });

      {
        /*if (!sTimings || sTimings.length === 0) {
        if (values.sstartDate) {
          loadAvailableTimes({
            date: values.sstartDate,
            studentId: event.target.value,
            bookingId: values.bookingId,
            type,
          });
        }
      }*/
      }
    }
  };

  const isDisableSave = () => {
    if (subscriptions?.length == 0) {
      return true;
    }

    return false;
  };
  const handleChildInfoClick = () => {
    setOpenChildInfoDialog(true);
  };

  const handleCloseChildInfoDialog = () => {
    setOpenChildInfoDialog(false);
  };

  if (openChildInfoDialog) {
    return (
      <StudentInfoForm
        hide={handleCloseChildInfoDialog}
        studentId={values.studentId}
      />
    );
  }

  return (
    <FormControl noValidate autoComplete="off">
      <Div
        sx={{
          "& .MuiTextField-root": {
            mb: 3,
            mt: 0.5,
          },
        }}
      >
        {!isEditable && (
          <FormControl fullWidth sx={{ mb: 3, mt: 1 }}>
            <InputLabel id="demo-multiple-checkbox-label">
              {t("parent.title.child")}
            </InputLabel>
            <Select
              disabled={
                values.teacherFeedback?.ratings?.length > 0 ||
                !!values.cancelled
              }
              value={values.studentId}
              label={t("parent.title.child")}
              onChange={handleChange("studentId")}
              renderValue={(selected) => {
                // Find the selected child based on the studentId
                const selectedChild = children?.find(
                  (child) => child.studentId === selected,
                );

                console.log("selected----------------------", selected);
                // Display only the selected child's name
                return (
                  <Div sx={{ display: "flex", alignItems: "center" }}>
                    <ListItemAvatar>
                      {selectedChild && selectedChild.images?.length > 0 ? (
                        <DDImage
                          path={selectedChild.images[0]}
                          alt={
                            selectedChild.firstName +
                            " " +
                            selectedChild.lastName
                          }
                        />
                      ) : (
                        <Avatar
                          alt={
                            selectedChild?.firstName +
                            " " +
                            selectedChild?.lastName
                          }
                        />
                      )}
                    </ListItemAvatar>
                    {selectedChild?.firstName} {selectedChild?.lastName}
                  </Div>
                );
              }}
            >
              {children &&
                children.map((item) => (
                  <MenuItem key={item.studentId} value={item.studentId}>
                    <ListItemAvatar>
                      {item.images?.length > 0 ? (
                        <DDImage
                          path={item.images[0]}
                          alt={item.firstName + " " + item.lastName}
                        />
                      ) : (
                        <Avatar alt={item.firstName + " " + item.lastName} />
                      )}
                    </ListItemAvatar>
                    {item.firstName} {item.lastName}
                  </MenuItem>
                ))}
            </Select>

            {children?.length > 0 &&
              values.bookingId &&
              values.teacherFeedback?.ratings?.length === 0 &&
              !values.cancelled && (
                <LoadingButton
                  type="button"
                  variant="contained"
                  size="medium"
                  onClick={() => {
                    updateStudentForBooking({
                      bookingId: values.bookingId,
                      studentId: values.studentId,
                    });
                  }}
                  loading={isUSFBLoading}
                  sx={{
                    width: "20%",
                    mt: 1,
                  }}
                >
                  {t("common.updateBtn")}
                </LoadingButton>
              )}
            {usfbError && <Alert severity="error">{usfbError}</Alert>}
          </FormControl>
        )}

        {globalState?.booking && isEditable && (
          <FormControl fullWidth sx={{ mt: 1 }}>
            <Autocomplete
              filterOptions={(x) => x}
              disabled={
                pastDate ||
                values.teacherFeedback?.ratings?.length > 0 ||
                !!values.cancelled
              }
              options={searchResults}
              value={
                // Show only if present in options; no fallback to values.student after clear
                searchResults.find((c) => c.studentId === values.studentId) ||
                null
              }
              isOptionEqualToValue={(option, value) =>
                option?.studentId === value?.studentId
              }
              getOptionLabel={(option) =>
                typeof option === "string"
                  ? option
                  : `${option.firstName || ""} ${option.lastName || ""}`.trim()
              }
              noOptionsText={
                inputValue.length >= 2
                  ? t("parent.title.noStudentAvailable") // shown when user typed but found nothing
                  : t("parent.title.enterStudentName") // shown initially before typing
              }
              // ✅ include `reason`
              onChange={(e, newValue, reason) => {
                if (reason === "clear") {
                  const removedId = values.studentId;
                  setValues((prev) => ({
                    ...prev,
                    studentId: "",
                    studentName: "",
                    student: undefined, // stop fallback showing in input/dropdown
                  }));
                  // remove the cleared item from the options list too
                  setSearchResults((prev) =>
                    prev.filter((s) => s.studentId !== removedId),
                  );
                  return;
                }

                if (typeof newValue === "string") {
                  setValues((prev) => ({
                    ...prev,
                    studentId: "",
                    studentName: newValue,
                    student: undefined,
                  }));
                } else if (newValue) {
                  setValues((prev) => ({
                    ...prev,
                    studentId: newValue.studentId,
                    studentName:
                      `${newValue.firstName || ""} ${newValue.lastName || ""}`.trim(),
                    student: undefined, // keep source of truth in options only
                  }));

                  loadActiveSubscriptions({
                    studentId: newValue.studentId,
                    subscriptionId: values.subscriptionId,
                    date: values.sstartDate,
                  });
                } else {
                  // when newValue === null but not via "clear" (e.g., escape)
                  setValues((prev) => ({
                    ...prev,
                    studentId: "",
                    studentName: "",
                    student: undefined,
                  }));
                }
              }}
              onInputChange={(e, value, reason) => {
                if (reason === "clear") {
                  // user clicked the X — wipe options too
                  setSearchResults([]);
                  return;
                }
                if (reason !== "input") return;

                setValues((prev) => ({ ...prev, studentName: value }));
                if (value.length >= 2) {
                  loadStudents(
                    { search: value, page: 1, size: 10 },
                    {
                      onSuccess: (res) => setSearchResults(res?.students || []),
                      onError: () => setSearchResults([]),
                    },
                  );
                } else {
                  setSearchResults([]);
                }
              }}
              renderInput={(params) => {
                const selectedChild =
                  searchResults.find((c) => c.studentId === values.studentId) ||
                  null;

                return (
                  <TextField
                    {...params}
                    label={t("parent.title.enterStudentName")}
                    InputProps={{
                      ...params.InputProps,
                      startAdornment: selectedChild ? (
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                            mr: 1,
                          }}
                        >
                          {selectedChild.images?.[0] ? (
                            <DDImage
                              path={selectedChild.images[0]}
                              alt={values.studentName}
                              style={{
                                width: 32,
                                height: 32,
                                borderRadius: "50%",
                              }}
                            />
                          ) : (
                            <Avatar
                              alt={values.studentName}
                              sx={{ width: 32, height: 32 }}
                            />
                          )}
                        </Box>
                      ) : null,
                    }}
                  />
                );
              }}
              renderOption={(props, option) => (
                <li {...props} key={option.studentId}>
                  <ListItemAvatar>
                    {option.images?.length > 0 ? (
                      <DDImage
                        path={option.images[0]}
                        alt={option.firstName + " " + option.lastName}
                      />
                    ) : (
                      <Avatar alt={option.firstName + " " + option.lastName} />
                    )}
                  </ListItemAvatar>
                  {option.firstName} {option.lastName}
                </li>
              )}
            />

            {values.studentId &&
              values.bookingId &&
              !pastDate &&
              values.teacherFeedback?.ratings?.length === 0 &&
              !values.cancelled && (
                <LoadingButton
                  type="button"
                  variant="contained"
                  size="medium"
                  onClick={() => {
                    updateStudentForBooking({
                      bookingId: values.bookingId,
                      studentId: values.studentId,
                    });
                  }}
                  loading={isUSFBLoading}
                  sx={{ width: "20%", mb: 2 }}
                >
                  {t("common.updateBtn")}
                </LoadingButton>
              )}
            {usfbError && <Alert severity="error">{usfbError}</Alert>}
          </FormControl>
        )}

        <FormControl fullWidth sx={{ mb: 3, mt: 1 }}>
          <InputLabel id="demo-multiple-checkbox-label">
            {t("calendar.subscription")}
          </InputLabel>
          <Select
            disabled={!isEditable || pastDate || !values?.studentId}
            value={values.subscriptionId}
            label={t("parent-subscription.title.sub")}
            onChange={handleChange("subscriptionId")}
            renderValue={(selected) => {
              // Find the selected child based on the studentId
              const selectedChild = subscriptions?.find(
                (child) => child.subscriptionId === selected,
              );

              // Display only the selected child's name
              return (
                <Div sx={{ display: "flex", alignItems: "center" }}>
                  {selectedChild?.plan?.name}
                </Div>
              );
            }}
          >
            {subscriptions.map((item) => (
              <MenuItem key={item.subscriptionId} value={item.subscriptionId}>
                <div>
                  {item.plan.name}
                  <br />
                  {t("common.expired")}{" "}
                  {moment(item.expiredDate).format("YYYY-MM-DD")}
                  <br />
                  {t("common.bookingUtilize")} {item.noOfUsedBooking}/
                  {item.noOfBooking}
                </div>
                {item.subscriptionId === subscription?.subscriptionId && (
                  <div>
                    <Chip
                      label={t("common.recommended")}
                      color={"success"}
                      size={"small"}
                    />
                  </div>
                )}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl fullWidth sx={{ mb: 1, mt: 1 }}>
          {!isEditable && values.teacher?.teacherId && (
            <>
              <InputLabel id="demo-multiple-checkbox-label">
                {t("parent.title.teacher")}
              </InputLabel>
              <Select
                disabled={true}
                value={values.teacher?.teacherId}
                label={t("parent.title.teacher")}
                renderValue={(selected) => {
                  // Find the selected child based on the studentIdal

                  const selectedChild = values.teacher;

                  // Display only the selected child's name
                  return (
                    <Div sx={{ display: "flex", alignItems: "center" }}>
                      <ListItemAvatar>
                        {selectedChild && selectedChild.images?.length > 0 ? (
                          <DDImage
                            path={selectedChild.images[0]}
                            alt={
                              selectedChild.firstName +
                              " " +
                              selectedChild.lastName
                            }
                          />
                        ) : (
                          <Avatar
                            alt={
                              selectedChild?.firstName +
                              " " +
                              selectedChild?.lastName
                            }
                          />
                        )}
                      </ListItemAvatar>
                      {selectedChild?.firstName} {selectedChild?.lastName}
                    </Div>
                  );
                }}
              >
                <MenuItem
                  key={"key-teacher-" + values?.teacher?.teacherId}
                  value={values?.teacher?.teacherId}
                >
                  <ListItemAvatar>
                    {values?.teacher?.images?.length > 0 ? (
                      <DDImage
                        path={values?.teacher?.images[0]}
                        alt={
                          values?.teacher?.firstName +
                          " " +
                          values?.teacher?.lastName
                        }
                      />
                    ) : (
                      <Avatar
                        alt={
                          values?.teacher?.firstName +
                          " " +
                          values?.teacher?.lastName
                        }
                      />
                    )}
                  </ListItemAvatar>
                  {values?.teacher?.firstName} {values?.teacher?.lastName}
                </MenuItem>
              </Select>
            </>
          )}

          {isEditable && (
            <>
              <Autocomplete
                disableClearable
                disabled={!isEditable}
                options={
                  Array.isArray(options)
                    ? options
                    : normalizeTeacherOptions(options)
                }
                filterOptions={(x) => x}
                getOptionLabel={(option) =>
                  typeof option === "string"
                    ? option
                    : `${option?.firstName || ""} ${option?.lastName || ""}`.trim()
                }
                noOptionsText={
                  inputValue.length >= 2
                    ? t("parent.title.noTeacherAvailable") // shown when user typed but found nothing
                    : t("parent.title.enterTeacherName") // shown initially before typing
                }
                onChange={(e, newValue) => {
                  if (newValue) {
                    // set teacherId
                    handleChange("teacherId")({
                      target: { value: newValue.teacherId },
                    });

                    // reset time UI for a fresh teacher choice
                    setValues((prev) => ({ ...prev, startTime: "" }));
                    setSTimings([]);

                    // build the date window (same as global)
                    const start = new Date();
                    start.setDate(1);
                    const end = new Date(start);
                    start.setMonth(start.getMonth() - 3);
                    end.setMonth(end.getMonth() + 4);

                    // 1) load available dates for this teacher
                    loadAvailableDatesByTeacher(
                      {
                        startDate: start,
                        endDate: end,
                        type: "courses",
                        teacherId: newValue.teacherId,
                      },
                      {
                        // 2) after dates return, optionally prefetch times if a date is already selected
                        onSuccess: (res) => {
                          const teacherDates = res?.availableDates || [];
                          setAvailableDates(teacherDates);

                          if (values.sstartDate) {
                            const dayStr = moment(values.sstartDate).format(
                              "YYYY-MM-DD",
                            );
                            if (teacherDates.includes(dayStr)) {
                              loadAvailableTimesByTeacher({
                                date: dayStr,
                                studentId: values.studentId,
                                teacherId: newValue.teacherId,
                                type: "courses",
                              });
                            }
                          }
                        },
                        onError: () => {
                          setAvailableDates([]);
                          setSTimings([]);
                        },
                      },
                    );
                  } else {
                    // cleared teacher
                    handleChange("teacherId")({ target: { value: "" } });
                    setAvailableDates([]);
                    setSTimings([]);
                    setValues((prev) => ({ ...prev, startTime: "" }));
                  }
                }}
                onInputChange={(e, newInput) => {
                  setInputValue(newInput);
                  if (newInput.length >= 2) {
                    loadEvaluators({ search: newInput });
                  } else {
                    setOptions([]);
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={t("parent.title.enterTeacherName")}
                    variant="outlined"
                  />
                )}
                renderOption={(props, option) => {
                  console.log("Rendering option-----:", option);
                  return (
                    <li {...props} key={option.teacherId}>
                      <ListItemAvatar>
                        {option.images?.length > 0 ? (
                          <DDImage
                            path={option.images[0]}
                            alt={option.firstName + " " + option.lastName}
                          />
                        ) : (
                          <Avatar
                            alt={option.firstName + " " + option.lastName}
                          />
                        )}
                      </ListItemAvatar>
                      {option.firstName} {option.lastName}
                    </li>
                  );
                }}
              />
            </>
          )}
        </FormControl>

        <FormControl fullWidth>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <Stack spacing={3}>
              <DesktopDatePicker
                disabled={
                  !isEditable ||
                  pastDate ||
                  !values?.studentId ||
                  !values?.teacherId
                }
                open={open}
                onOpen={(event) => {
                  setOpen(true);
                }}
                onClose={(event) => {
                  setOpen(false);
                }}
                shouldDisableDate={(day) => {
                  if (pastDate) return false;

                  if (!isEditable) return false;

                  if (
                    availableDates &&
                    availableDates.indexOf(moment(day).format("YYYY-MM-DD")) >
                      -1
                  ) {
                    if (subscriptions && values.subscriptionId) {
                      const subscription = subscriptions.find(
                        (ii) => ii.subscriptionId === values.subscriptionId,
                      );
                      const expiredDate = new Date(subscription.expiredDate);
                      day.setHours(0, 0, 0);
                      expiredDate.setHours(0, 0, 0);
                      console.log(
                        subscription,
                        "day",
                        day,
                        "expiredDate",
                        expiredDate,
                      );
                      if (day <= expiredDate) {
                        return false;
                      }
                      return true;
                    }

                    return false;
                  } else {
                    return true;
                  }
                }}
                minDate={true ? null : pastDate ? null : minDate}
                maxDate={true ? null : pastDate ? null : maxDate}
                loading={false}
                label={t("common.date")}
                format="dd/MM/yyyy"
                value={values.sstartDate}
                onChange={(event, newValue) => {
                  const startDate = moment(event).format("YYYY-MM-DD");
                  const sstartDate = event;
                  setValues({
                    ...values,
                    startDate,
                    sstartDate,
                    startTime: "",
                  });
                  setSTimings([]);

                  if (values.teacherId) {
                    // teacher-specific times
                    loadAvailableTimesByTeacher({
                      date: startDate,
                      studentId: values.studentId,
                      teacherId: values.teacherId,
                      type: "courses",
                    });
                  }
                }}
                renderInput={(params) => <TextField {...params} />}
              />
            </Stack>
          </LocalizationProvider>
        </FormControl>

        <FormControl fullWidth sx={{ mb: 2, mt: 1 }}>
          {!isEditable && (
            <TextField
              label={t("parent.title.time")}
              disabled={!isEditable}
              value={values.startTime}
            />
          )}
          {isEditable && (
            <>
              <InputLabel id="demo-simple-select-label">
                {t("parent.title.time")}
              </InputLabel>
              <Select
                disabled={
                  !isEditable ||
                  !values?.studentId ||
                  !values?.startDate ||
                  !values?.teacherId
                }
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={values.startTime}
                label={t("parent.title.time")}
                onChange={handleChange("startTime")}
              >
                {sTimings.map((item, index) => (
                  <MenuItem key={"key-timing-" + index} value={item.value}>
                    {item.label}
                  </MenuItem>
                ))}
              </Select>
            </>
          )}
        </FormControl>

        <FormControl fullWidth>
          <TextField
            disabled={!isEditable || pastDate}
            id="outlined-multiline-static"
            label={t("common.desc")}
            multiline
            rows={2}
            value={values.description}
            name="description"
            onChange={handleChange("description")}
          />
        </FormControl>

        {!showDeleteConfirmation && !values.cancelled && (
          <Typography variant="body2">{t("parent.title.txt")}</Typography>
        )}

        {/*<Stack
          sx={{
            mb: 2,
            width: "90%",
            mx: "auto",
            display: "block",
            position: "relative", // Add position relative to enable absolute positioning of loader
          }}
          spacing={2}
        >
          {errMsg && <Alert severity="error">{errMsg}</Alert>}
        </Stack>*/}

        <Box
          sx={{
            width: "100%", // full width of the form container
            minHeight: 50,
            mb: 2,
            mt: 1,
          }}
        >
          {errMsg && <Alert severity="error">{errMsg}</Alert>}
        </Box>

        {!showCancelConfirmation && !showDeleteConfirmation && (
          <ButtonGroup
            sx={{
              mb: 2,
              display: "flex",
              justifyContent: "center",
            }}
            disableElevation
            variant="contained"
            color={"warning"}
          >
            <Button
              type="submit"
              variant="contained"
              size="medium"
              onClick={() => {
                hide();
              }}
              sx={{
                width: "20%",
                height: "10%",
                mr: 0.5,
              }}
            >
              {t("common.closeBtn")}
            </Button>
            <Button
              size="medium"
              variant="contained"
              onClick={handleChildInfoClick}
              sx={{ mr: 1, height: "10%", width: "25%" }}
            >
              {t("common.studentBtn")}
            </Button>
            {isEditable && (
              <LoadingButton
                type="submit"
                variant="contained"
                size="medium"
                disabled={isDisableSave()}
                onClick={handleSaveBooking}
                sx={{
                  width: "25%",
                  mr: 0.5,
                }}
                loading={isBLoading}
              >
                {/^true$/i.test(values.cancelled) ? (
                  <>Undo</>
                ) : values.bookingId ? (
                  t("common.updateBtn")
                ) : (
                  t("common.saveBtn")
                )}
              </LoadingButton>
            )}

            {values.bookingId &&
              values.teacherFeedback?.ratings?.length === 0 && (
                <Button
                  type="button"
                  variant="contained"
                  size="medium"
                  onClick={() => {
                    setShowDeleteConfirmation(true);
                  }}
                  sx={{
                    width: "20%",
                    mr: 0.5,
                  }}
                >
                  {t("common.deleteBtn")}
                </Button>
              )}

            {!pastDate &&
              values.teacherFeedback?.ratings?.length === 0 &&
              !values.cancelled &&
              values.bookingId && (
                <Button
                  type="button"
                  variant="contained"
                  size="medium"
                  onClick={() => {
                    setShowCancelConfirmation(true);
                  }}
                  sx={{
                    width: "20%",
                    mr: 0.5,
                  }}
                >
                  {t("common.cancelBtn")}
                </Button>
              )}

            {values.teacherFeedback?.ratings?.length > 0 && (
              <Button
                type="button"
                variant="contained"
                size="medium"
                onClick={() => {
                  showTeacherFeedback(values.teacherFeedback);
                }}
                sx={{
                  width: "30%",
                }}
              >
                {t("feedbackForm.feedback")}
              </Button>
            )}
          </ButtonGroup>
        )}
        {showCancelConfirmation && (
          <>
            <TextField
              id="cancelReason"
              label="Reason for cancellation"
              variant="outlined"
              size="small"
              margin="dense"
              multiline
              rows={2}
              onChange={(e) => setCancelReason(e.target.value)}
              sx={{ width: "100%" }}
            />
            <Alert
              severity="warning"
              sx={{ mb: 1, display: "flex", alignItems: "center" }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <span style={{ marginRight: "15px" }}>
                  {t("common.cancelTxt")}
                </span>
                <Stack direction="row" spacing={2}>
                  <LoadingButton
                    loading={isCBLoading}
                    onClick={handleCancelBooking}
                  >
                    {t("common.yesBtn")}
                  </LoadingButton>
                  <Button
                    onClick={() => {
                      setShowCancelConfirmation(false);
                    }}
                  >
                    {t("common.noBtn")}
                  </Button>
                </Stack>
              </div>
            </Alert>
          </>
        )}

        {showDeleteConfirmation && (
          <Alert
            severity="warning"
            sx={{ mb: 1, display: "flex", alignItems: "center" }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
              }}
            >
              <span style={{ marginRight: "15px" }}>
                {t("common.deleteTxt")}
              </span>
              <Stack direction="row" spacing={2}>
                <LoadingButton
                  loading={isDBLoading}
                  onClick={() => {
                    deleteBooking(values.bookingId);
                  }}
                >
                  {t("common.yesBtn")}
                </LoadingButton>
                <Button
                  onClick={() => {
                    setShowDeleteConfirmation(false);
                  }}
                >
                  {t("common.noBtn")}
                </Button>
              </Stack>
            </div>
          </Alert>
        )}
      </Div>
    </FormControl>
  );
};

export default BookingForm;
